import { Phone } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const StickyMobileCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  // Hide on admin pages and book-inspection page
  const hiddenPaths = ['/admin', '/book-inspection'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));

  // Show CTA after a short delay or when user scrolls
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHasScrolled(true);
      }
    };

    // Show after 1.5s or when scrolled
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Also show immediately if user has scrolled
  useEffect(() => {
    if (hasScrolled) {
      setIsVisible(true);
    }
  }, [hasScrolled]);

  if (shouldHide || !isVisible) return null;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-border/50 shadow-[0_-4px_20px_-1px_rgba(0,0,0,0.12)] safe-area-bottom sticky-cta-enter tap-highlight-none">
      <div className="p-3">
      <div className="flex gap-2">
        <Button
          variant="cta"
          onClick={() => {
            // Track Meta Pixel Contact event
            if (typeof window !== 'undefined' && (window as any).fbq) {
              (window as any).fbq('track', 'Contact', {
                content_name: 'Get Free Inspection - Sticky Mobile CTA'
              });
            }
            navigate("/book-inspection");
          }}
          className="flex-1 font-semibold py-3 touch-target btn-press"
        >
          Get Free Inspection
        </Button>
        <a
          href="tel:+13462200989"
          className="flex items-center justify-center gap-2 px-4 py-3 bg-secondary text-white rounded-md font-semibold transition-all duration-200 active:scale-95 touch-target btn-press"
          aria-label="Call us at (346) 220-0989"
        >
          <Phone className="w-5 h-5" />
        </a>
      </div>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
